import { Button, TextField } from "@mui/material";
import Modal from "../Modal";

const ReportForm = ({
  open,
  onClose,
  onAction,
  customerData,
  handleInputChange,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onAction();
  };

  return (
    <Modal
      open={open}
      handleClose={onClose}
      style={{
        width: "360px",
      }}
    >
      <div className="flex flex-col gap-4">
        <div className="text-lg leading-tight mb-4">
          Merci de nous donner un moyen de vous joindre afin qu'on puisse vous
          rembourser, ou corriger la situation.
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <TextField
              label="Nom"
              variant="outlined"
              fullWidth
              value={customerData.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
            />
          </div>
          <div>
            <TextField
              label="Téléphone"
              variant="outlined"
              type="tel"
              fullWidth
              value={customerData.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
            />
          </div>
          <div className="flex justify-end">
            <Button type="submit" variant="contained" color="primary">
              Envoyer
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ReportForm;
